import notEmptyNode from "../notEmptyNode/index.js";
function transformData(data) {
    if (data) {
        if (!data.edges || 0 === data.edges.length) return [];
        return data.edges.filter(notEmptyNode).map(({ node })=>node);
    }
    return [];
}
const src_transformData = transformData;
export default src_transformData;
